import { Button } from '@progress/kendo-react-buttons';
import Body from 'commons/card/Body';
import CollapsableCard from 'commons/card/CollapsableCard';
import CustomModal from 'commons/modal/CustomModal';
import * as dates from 'commons/models/dates';
import { Input, Checkbox } from '@progress/kendo-react-inputs';
import * as gestion from 'commons/models/gestion';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import 'scss/_projectDetail.scss';
import CreateProjectModal from './modals/CreateProjectModal';
import ApprobationProduitButtons from 'commons/modal/ApprobationProduitButtons';
import { useNavigate } from 'react-router-dom';
import { useAddProjectMutation, useGetCampagneTypesQuery, useGetMagasinsQuery, useRemoveProjectMutation, useUpdateProjectMutation } from '../../../redux/api/cache';

export default function ProjectDetail(props) {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [modifyModalVisible, setModifyModalVisible] = useState(false);
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { data: campagneTypes } = useGetCampagneTypesQuery();
  const { data: stores } = useGetMagasinsQuery();
  const [addProject] = useAddProjectMutation();

  const getDates = (date) => {
    let formattedDatev = date;
    if (date instanceof Date)
      formattedDatev = dates.dateQueryFormatReverse(date);
    return dates.dateQueryFormatReverse(formattedDatev);
  };

  const [updateProject] = useUpdateProjectMutation();
  const [removeProject] = useRemoveProjectMutation();

  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    type,
    optional,
    wrapperStyle,
    ...others
  } = props;

  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : '';
  const errorId = showValidationMessage ? `${id}_error` : '';

  return (
    <div>
      <div
        style={{
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
          margin: '0 15px 0 15px',
        }}
      >
        <div
          className="inline"
          style={{
            backgroundColor: 'white',
            border: '1px #f3f5f5 solid',
            borderBottom: '0px white solid',
            borderRadius: '1px',
            boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
            padding: '15px 30px 15px 30px',
            marginTop: '15px',
          }}
        >
          <h1
            style={{
              textTransform: 'uppercase',
              color: 'dimgrey',
              fontWeight: 'bold',
              fontSize: '22px',
            }}
            className="me-auto"
          >
            {props.data.camp_descr}
          </h1>
          {props.data.camp_seq_parent !== 0 && (
            <a
              style={{
                backgroundColor: '#147bfc',
                color: 'white',
                borderRadius: '50px',
                boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
                width: '150px',
                fontSize: '17px',
                textAlign: 'center',
                height: '36px',
                padding: '6px',
              }}
              target="_blank"
              rel="noreferrer"
              href={`/#${location.pathname.split('Projets/')[0] +
                'Projets/' +
                props.data.camp_seq_parent
                }`}
            >
              Projet parent
              <span
                style={{
                  fontSize: '12px',
                  marginLeft: '10px',
                  backgroundColor: 'transparent',
                }}
                className={'k-icon k-font-icon k-i-hyperlink-open'}
              ></span>
            </a>
          )}
        </div>

        <CollapsableCard
          type="none"
          canCollapse={false}
          style={{
            margin: '0',
            marginBottom: '20px',
          }}
        >
          <Body>
            <div
              className="inline"
              style={{
                margin: '15px 0 20px 0',
              }}
            >
              <div className="me-auto">
                <Button
                  style={{
                    margin: '2px',
                    marginRight: '15px',
                  }}
                  className="whiteButton"
                  onClick={() => setModifyModalVisible(true)}
                >
                  Modifier
                </Button>
                {true && props.data.camp_seq_parent === 0 && (
                  <Button
                    style={{ margin: '2px' }}
                    className="whiteButton"
                    onClick={() => setCreateModalVisible(true)}
                  >
                    Créer un sous-projet
                  </Button>
                )}
              </div>
              <Button
                icon={'trash'}
                className="whiteButton"
                style={{
                  margin: '2px',
                  borderRadius: '50%',
                  width: '34px',
                  height: '34px',
                }}
                onClick={() => setDeleteModalVisible(true)}
              ></Button>
            </div>
            <div
              className="row customRow"
              style={{
                marginBottom: '7px',
              }}
            >
              <div className="col-md-1 customCol">
                <span>Numéro :</span>
              </div>
              <div className="col-md-2 customCol">
                <span>Type :</span>
              </div>
              <div className="col-md-2 customCol">
                <span>Bannières :</span>
              </div>
              <div className="col-md-3 customCol">
                <span>Magasin :</span>
              </div>
              <div className="col-md-2 customCol">
                <span>Dates :</span>
              </div>
              <div
                className="col-md-2"
                style={{
                  color: '#a5a5a5',
                  fontWeight: 'bold',
                }}
              >
                <span>Confirmé</span>
              </div>
            </div>
            <div
              className="row customRow"
              style={{
                marginBottom: '15px',
              }}
            >
              <div className="col-md-1 customCol">
                <Input
                  valid={valid}
                  type={type}
                  id={id}
                  readOnly={true}
                  ariaDescribedBy={`${hintId} ${errorId}`}
                  value={props.data.camp_num}
                  className="customInput"
                  {...others}
                />
              </div>
              <div className="col-md-2 customCol">
                <Input
                  valid={valid}
                  type={type}
                  id={id}
                  readOnly={true}
                  ariaDescribedBy={`${hintId} ${errorId}`}
                  value={
                    gestion.gestionKeyDescr(
                      campagneTypes?.data,
                      props.data.camptyp_cd,
                      'camptyp_cd',
                      'camptyp_descr'
                    ) +
                    ' (' +
                    gestion.gestionKeyDescr(
                      campagneTypes?.data,
                      props.data.camptyp_cd,
                      'camptyp_cd',
                      'camptyp_categ'
                    ) +
                    ')'
                  }
                  className="customInput"
                  {...others}
                />
              </div>
              <div className="col-md-2 customCol">
                <Input
                  valid={valid}
                  type={type}
                  id={id}
                  readOnly={true}
                  ariaDescribedBy={`${hintId} ${errorId}`}
                  value={props.data.maggrp_cd}
                  className="customInput"
                  {...others}
                />
              </div>
              <div className="col-md-3 customCol">
                <Input
                  valid={valid}
                  type={type}
                  id={id}
                  readOnly={true}
                  ariaDescribedBy={`${hintId} ${errorId}`}
                  title={gestion.storesName(
                    stores?.data,
                    props.data.mag_num_lst
                  )}
                  value={gestion.storesName(
                    stores?.data,
                    props.data.mag_num_lst
                  )}
                  className="customInput"
                  {...others}
                />
              </div>
              <div className="col-md-2 customCol">
                <Input
                  valid={valid}
                  type={type}
                  id={id}
                  readOnly={true}
                  ariaDescribedBy={`${hintId} ${errorId}`}
                  value={`${getDates(
                    props.data.camp_dt_deb
                  )} au ${getDates(props.data.camp_dt_fin)}`}
                  className="customInput"
                  {...others}
                />
              </div>
              <div className="col-md-2">
                <Checkbox
                  disabled={true}
                  style={{
                    width: '38px',
                    height: '38px',
                    borderColor: 'lightgrey',
                  }}
                  value={props.data.camp_confirme}
                />
              </div>
            </div>
            <span
              style={{
                fontSize: '17px',
                color: 'dimgrey',
                fontWeight: 'bold',
              }}
            >
              Notes:
              <span style={{ fontWeight: 'normal' }}>
                {' '}
                {props.data.camp_note !== ''
                  ? props.data.camp_note
                  : 'N/A'}
              </span>
            </span>
            <div style={{ float: 'right', marginRight: '10px', fontWeight: "normal", width: '100%' }}>
              <ApprobationProduitButtons campSeq={props.data.camp_seq} />
            </div>

          </Body>
          {modifyModalVisible && (
            <CreateProjectModal
              create={async (values) => {
                await updateProject(values);
              }}
              project={props.data}
              toggleDialog={() => {
                setModifyModalVisible(false);
              }}
            />
          )}
          {createModalVisible && (
            <CreateProjectModal
              create={async (values) => {
                let result = await addProject(values).unwrap();
                if (result.success) {
                  navigate(
                    location.pathname.split('Projets/')[0] +
                    'Projets/' +
                    result.data[0].camp_seq
                  );
                }
              }}
              parentproject={props.data}
              project={undefined}
              toggleDialog={() => {
                setCreateModalVisible(false);
              }}
            />
          )}
          {deleteModalVisible && (
            <CustomModal
              width={'15%'}
              title="Confirmation"
              onClose={() => {
                setDeleteModalVisible(!deleteModalVisible);
              }}
              body={
                <p style={{ color: 'black' }}>Supprimer {props.data.camp_descr} ?</p>
              }
              buttons={[
                {
                  onClick: async () => {
                    let result = await removeProject(props.data.camp_seq).unwrap();
                    if (result.success) {
                      let url = location.pathname.split('/Projets');
                      navigate(url[0]);
                      setDeleteModalVisible(!deleteModalVisible);
                    }
                  },
                  text: 'Oui',
                },
                {
                  onClick: () => {
                    setDeleteModalVisible(!deleteModalVisible);
                  },
                  text: 'Non',
                },
              ]}
            />
          )}
        </CollapsableCard>
      </div>
    </div>
  );
}

ProjectDetail.propTypes = {
  data: PropTypes.shape({
    camp_confirm: PropTypes.any,
    camp_descr: PropTypes.any,
    camp_descr_parent: PropTypes.any,
    camp_dt_deb: PropTypes.any,
    camp_dt_fin: PropTypes.any,
    camp_note: PropTypes.any,
    camp_num: PropTypes.any,
    camp_seq: PropTypes.any,
    camp_seq_parent: PropTypes.number,
    camptyp_cd: PropTypes.any,
    mag_num_lst: PropTypes.any,
    maggrp_cd: PropTypes.any,
    camp_confirme: PropTypes.any
  }),
};
